module.exports = __webpack_public_path__ + "static/atb-pga-logo-f1ddf2d23663463f21b9dec51a034878.jpg";